import { render, staticRenderFns } from "./CollectionCarousel.sync.vue?vue&type=template&id=bbdf7574&"
import script from "./CollectionCarousel.sync.vue?vue&type=script&lang=js&"
export * from "./CollectionCarousel.sync.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports